// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ffac61b2","879":"0f1a1485"}[chunkId] + ".chunk.js";
};